import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../../Components/NavBar/navbar';
import './Auth.css';
import { API_ENDPOINTS } from '../../utils/config';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(API_ENDPOINTS.FORGOT_PASSWORD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        setSuccess(
          data.message ||
            'If an account exists for that email, a password reset link has been sent.'
        );
      } else if (response.status === 503) {
        setError(
          data.error ||
            'Password reset email could not be sent right now. Please try again later.'
        );
      } else {
        setError(data.error || 'Could not request a password reset.');
      }
    } catch (err) {
      console.error('Forgot-password request failed:', err);
      setError('Server not responding. Try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <NavBar />
      <div className="auth-page-main">
        <div className="auth-container">
          <div className="auth-box">
            <div className="auth-brand">
              Evolv<span>e<sup>x</sup></span>
            </div>
            <h2>Forgot password</h2>
            <p className="auth-subtitle">
              Enter your account email and we&apos;ll send a reset link.
            </p>

            {error && <div className="auth-error">{error}</div>}
            {success && <div className="auth-success">{success}</div>}

            {!success && (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    autoComplete="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                  />
                </div>

                <button type="submit" className="btn-primary" disabled={loading}>
                  {loading ? 'Sending…' : 'Send reset link'}
                </button>
              </form>
            )}

            <p className="auth-footer">
              <Link to="/auth/login">Back to sign in</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
